module.exports = __webpack_public_path__ + "img/nineteen.dd8992ed.svg";